import React, { PropTypes } from 'react'
import { Breadcrumb, Button, Spinner, Classes, FocusStyleManager, Intent, Alert } from '@blueprintjs/core'
import service from '~/services/kitchenDepartmentService'
import './kitchen-department.scss'
import Table from './Table'
import { EDIT_MODE } from './constants'
import AssignPrinter from './AssignPrinter'
import SetWorkflow from './SetWorkflow'
import {
  Callout,
  PopRender,
  PopContainer,
} from '~/components/blueprint'

FocusStyleManager.onlyShowFocusOnTabs()

class KitchenDepartment extends React.Component {
  constructor(props){
    super(props)
    this.fetchDepartments = this.fetchDepartments.bind(this)
    this.setAction = this.setAction.bind(this)
    this.cleanAction = this.cleanAction.bind(this)
    this.add = this.add.bind(this)
    this.update = this.update.bind(this)
    this.assignPrinter = this.assignPrinter.bind(this)
    this.updateTarget = this.updateTarget.bind(this)
    this.remove = this.remove.bind(this)
    this.state = {
      loading: false,
      departments: [],
      action: null,
      error: null,
    }
  }
  componentDidMount(){
    this.fetchDepartments()
  }
  async fetchDepartments(){
    this.setState({loading: true})
    try {
      let {departments, printers} = await service.getAllWithPrinter(this.props.params.store_id)
      this.setState({departments, printers, error: null})
    } catch (e) {
      this.setState({error:e})
    } finally {
      this.setState({loading:false})
    }
  }
  async add(){
    let {action} = this.state
    try {
      await service.create(this.props.params.store_id, action.target)
      this.cleanAction()
      this.fetchDepartments()
    } catch (e) {
      action.error = e
      this.setState({action})
    }
  }
  async update(){
    let {action} = this.state
    try {
      await service.update(this.props.params.store_id, action.target)
      this.cleanAction()
      this.fetchDepartments()
    } catch (e){
      action.error = e
      this.setState({action})
    }
  }
  async assignPrinter(department){
    let {action} = this.state
    try {
      await service.assignPrinter(this.props.params.store_id, department)
      this.cleanAction()
      this.fetchDepartments()
    } catch (e){
      action.error = e
      this.setState({action})
    }
  }
  async remove(){
    let {action} = this.state
    let {id} = action.target
    try {
      await service.delete(this.props.params.store_id, id)
      this.cleanAction()
      this.fetchDepartments()
    } catch (e) {
      action.error = e
      this.setState({action})
    }
  }
  setAction(action){
    this.setState({action})
  }
  cleanAction(){
    this.setState({action: null})
  }
  updateTarget(event){
    let {name, value} = event.target
    let {action} = this.state
    action.target[name] = value
    this.setState({action})
  }
  render(){
    let {loading, departments, printers, action, error} = this.state
    if (loading){
      return (
        <div className="kitchen-department main-content state-wrapper">
          <Spinner className={Classes.LARGE}/>
        </div>
      )
    }
    if (error){
      return (
        <div className="kitchen-department main-content state-wrapper">
          <Callout error={error}/>
        </div>
      )
    }
    return (
      <PopContainer className="kitchen-department main-content">
        <ul className="pt-breadcrumbs">
          <li><Breadcrumb disabled text="Home"/></li>
          <li><Breadcrumb disabled text="Inventory Management"/></li>
          <li><Breadcrumb text="Kitchen Department"/></li>
        </ul>
        <Table
          departments={departments}
          setAction={this.setAction}
          storeId={this.props.params.store_id}
        />
        <div className="main-content-header">
          <span className="title">Kitchen Department</span>
          <Button
            text="New Kitchen Department"
            iconName="add"
            intent={Intent.PRIMARY}
            onClick={()=>this.setAction({target: {}, mode: EDIT_MODE.ADD})}
          />
        </div>
        {action?(
          <div>
            <PopRender
              title="New Kitchen Department"
              className="kd-dialog"
              isOpen={action.mode === EDIT_MODE.ADD}
              onClose={this.cleanAction}
            >
              <div className="line">
                <input
                  type="text"
                  className="pt-input pt-fill"
                  placeholder="Name"
                  name="name"
                  value={action.target.name}
                  onChange={this.updateTarget}
                />
              </div>
              <Callout error={action.error}/>
              <div className="line align-right">
                <Button text="Cancel" onClick={this.cleanAction}/>
                <Button text="Save" intent={Intent.PRIMARY} onClick={this.add}/>
              </div>
            </PopRender>
            <PopRender
              title="Edit Kitchen Department"
              className="kd-dialog"
              isOpen={action.mode === EDIT_MODE.EDIT}
              onClose={this.cleanAction}
            >
              <div className="line">
                <input
                  type="text"
                  className="pt-input pt-fill"
                  placeholder="Name"
                  name="name"
                  value={action.target.name}
                  onChange={this.updateTarget}
                />
              </div>
              <Callout error={action.error}/>
              <div className="line align-right">
                <Button text="Cancel" onClick={this.cleanAction}/>
                <Button text="Save" intent={Intent.PRIMARY} onClick={this.update}/>
              </div>
            </PopRender>
            <PopRender
              title="Select Printer"
              className="kd-dialog"
              isOpen={action.mode === EDIT_MODE.ASSIGN_PRINTER}
              onClose={this.cleanAction}
            >
              <AssignPrinter
                printers={printers}
                action={action}
                onSave={this.assignPrinter}
                onCancel={this.cleanAction}
              />
            </PopRender>
            <PopRender
              title="Set Workflow"
              className="kd-dialog"
              isOpen={action.mode === EDIT_MODE.SET_WORKFLOW}
              onClose={this.cleanAction}
            >
              <SetWorkflow
                action={action}
                storeId={this.props.params.store_id}
                onSaved={this.fetchDepartments}
                onCancel={this.cleanAction}
              />
            </PopRender>
            <Alert
              isOpen={action.mode === EDIT_MODE.REMOVE}
              cancelButtonText="Cancel"
              confirmButtonText="Yes, remove it"
              onConfirm={this.remove}
              onCancel={this.cleanAction}
              iconName="warning-sign"
              intent={Intent.DANGER}
            >
              Are you sure to remove it?
              <Callout error={action.error}/>
            </Alert>
          </div>
        ):null}
      </PopContainer>
    )
  }
}

KitchenDepartment.propTypes = {
  params: PropTypes.object.isRequired,
}

export default KitchenDepartment



/** WEBPACK FOOTER **
 ** ./client/pages/kitchen-department/index.js
 **/